import { useState } from 'react';
import Validator from 'validatorjs';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia/index.js';

const RetEfectFideicomisoForm = (props) => {
  const data = props.data;
  const [, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  const handleOnChange = (event) => {
    const validator = validate({
      ...props.data,
      ...event,
    });

    props.onFormDataChange(event, {
      step: 'base',
      name: 'isValidRetEfectFideicomiso',
      isValid: validator.passes(),
    });
  };

  const getRules = (data) => {
    return {
      MontRetRelPagFideic: ['required', 'decimal:6'],
      DescRetRelPagFideic: ['required', 'string', 'min:1', 'max:100'],
    };
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidator(newValidator);

    return validator;
  };

  const rules = getRules(data);

  return (
    <Form autoComplete="off">
      <Row>
        <Col
          sm
          md={3}
        >
          <FormControl
            type="number"
            label="Monto"
            name="MontRetRelPagFideic"
            placeholder=""
            help=""
            rules={rules.MontRetRelPagFideic}
            value={data.MontRetRelPagFideic}
            onChange={handleOnChange}
          />
        </Col>
        <Col
          sm
          md={12}
        >
          <FormControl
            as="textarea"
            label="Descripción"
            name="DescRetRelPagFideic"
            placeholder=""
            help=""
            minLength="1"
            maxLength="100"
            rules={rules.DescRetRelPagFideic}
            value={data.DescRetRelPagFideic}
            onChange={handleOnChange}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default RetEfectFideicomisoForm;
